import React from "react"

import FieldProto_ConditionForm from "../../../../../proto/render/condition/condition-form"
import ConditionTypeSelector from "../../../../../proto/render/condition/condition-type-selector"
import {ConditionType} from "../../../../../../model2/conditions/condition-types"
import FieldProto from "../../../../../proto/field-proto"
import FieldFormElementView from "../../../../../render/form-elemnent-view"
import FieldsFactory from "../../../../../fields-factory"
import {FieldType} from "../../../../../field-type"

// const debug = "FieldDateRange_ConditionForm"
const debug = false

export default class FieldDateRange_ConditionForm extends FieldProto_ConditionForm {

    render() {

        debug && console.log(debug, 'render', this.props.condition.type, this.state)

        let valueField : FieldProto | null = null

        switch (this.props.condition.type) {

            case ConditionType.DATERANGE_FIXED_INCLUDES:
            case ConditionType.DATERANGE_FIXED_OVERLAPS:
            case ConditionType.DATERANGE_FIXED_WITHIN:
                valueField = FieldsFactory.get({
                    type        : FieldType.DATE_RANGE,
                    fieldId     : 'value',
                    clearButton : false
                })

                // if (!this.props.condition.value) this.props.condition.value = moment()
                break

            case ConditionType.DATERANGE_RELATIVE_INCLUDES:
            case ConditionType.DATERANGE_RELATIVE_WITHIN:
            case ConditionType.DATERANGE_RELATIVE_OVERLAPS:
                valueField = FieldsFactory.get({
                    type    : FieldType.DATE_RANGE_RELATIVE,
                    fieldId : 'value'
                })

                // if (!this.props.condition.value) this.props.condition.value = 0 // Today

                break

            case ConditionType.IS_NULL:
            case ConditionType.NOT_NULL:
                // need nothing here
                break


            default:
                console.warn("#kdjd9383 FieldDaterage_ConditionForm: unknown condition type for value", this.props.condition.type)
        }


        return (
            <>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                {valueField &&
                    <FieldFormElementView className = "fl-no-shrink w-250 m-l-10"
                                          field     = {valueField}
                                          model     = {this.props.condition}
                                          onChange  = {this.onChangeValue}/> }
            </>
        )
    }
}